<script lang="ts">
  import type { TaskStep } from "../../EdbSettlementTask.svelte";
  import ListChecks from "~icons/ph/list-checks";
  import Bank from "~icons/ph/bank";
  import Pound from "~icons/ph/currency-gbp-bold";
  import SettlementStatusUI from "../../../components/SettlementStatusUI.svelte";

  let {
    currentStep,
    payoutAmount,
    showButtonRow = false,
  }: {
    currentStep: TaskStep;
    payoutAmount: number;
    showButtonRow?: boolean;
  } = $props();

  let steps = $derived([
    { name: "confirm", icon: ListChecks, label: "Confirm", subLabel: "Next", button: "Get your payment" },
    { name: "add_bank", icon: Bank, label: "Add bank", subLabel: "Next", button: "Add bank account" },
    { name: "receive_pay", ...receivePayStepArgs(currentStep) },
  ]);


  function receivePayStepArgs(currentStep: TaskStep) {
    return {
      icon: Pound,
      label: "Receive pay",
      subLabel: currentStep === "payment_sent" ? "Completed" : "In progress",
      button: "View details",
      additionalText: currentStep === "payment_sent" ? null : "We’ll notify you once payment is sent",
    };
  }
</script>
<SettlementStatusUI title="Your settlement" amount={payoutAmount} {steps} current={currentStep} {showButtonRow} />
